import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function InvestorRoadmapPage() {
  return <div className="min-h-screen bg-gray-50 font-sans text-[#111111]" data-id="element-4006" data-mp="1g1tjmnm62zhr">
      {/* Private Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-4007" data-mp="1l30u4ufp2cs4">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-4008" data-mp="1q0iz69qlc7uu">
          <div className="flex items-center space-x-4" data-id="element-4009" data-mp="selgocc7o2iw">
            <Link to="/investor-portal" className="text-gray-500 hover:text-[#631bb7] transition-colors" data-id="element-4010" data-mp="sbz7k89o9eyk">
              <ArrowLeftIcon size={20} data-id="element-4011" data-mp="12ayg7quftalk" />
            </Link>
            <div className="h-6 w-px bg-gray-200" data-id="element-4012" data-mp="172pzrhf6eg27"></div>
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-6" data-id="element-4013" data-mp="1749gf94qut4i" />
            <span className="bg-gray-100 text-gray-600 text-xs font-semibold px-2 py-1 rounded-full uppercase tracking-wide" data-id="element-4014" data-mp="el463h1i6050">
              Investor Portal
            </span>
          </div>
          <div className="text-sm text-gray-500" data-id="element-4015" data-mp="3bndixr82wd5v">
            Confidential & Proprietary
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12 space-y-12" data-id="element-4016" data-mp="36tsx0xjrf9n1">
        <div className="space-y-4" data-id="element-4017" data-mp="31vhm0jhqat38">
          <h1 className="text-4xl font-bold text-[#111111]" data-id="element-4018" data-mp="31ug9eal2dyje">
            Product Roadmap & Strategic Priorities
          </h1>
          <p className="text-xl text-gray-500" data-id="element-4019" data-mp="2sw491guebmdr">
            Building in phases — from education to unified orchestration
            platform.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-10 border border-gray-200 shadow-sm space-y-10" data-id="element-4020" data-mp="2nyubtf0rm6fd">
          {/* Intro */}
          <section data-id="element-4021" data-mp="m54sunw5u8bj">
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-4022" data-mp="m5mxa7sz7suj">
              Caveo's product roadmap balances rapid time-to-market with
              strategic defensibility. We build in phases, starting with
              high-impact education and layering in managed services, strategic
              integrations, and eventually a unified orchestration platform.
              Each phase has a clear milestone trigger before we move to the
              next.
            </p>
          </section>

          {/* 1. Our Build Philosophy */}
          <section className="border-t border-gray-100 pt-10" data-id="element-4023" data-mp="26np5ie1wsnno">
            <h2 className="text-2xl font-bold mb-6 text-[#631bb7]" data-id="element-4024" data-mp="2ue1iw4fxbcln">
              Our Build Philosophy
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed" data-id="element-4025" data-mp="2zbkxx6kg3ten">
              <p data-id="element-4026" data-mp="2ld3c5ee3oqzd">
                <span className="font-bold text-[#111111]" data-id="element-4027" data-mp="2lbjwnq09qjyn">
                  Start with teaching.
                </span>{' '}
                Education scales infinitely, builds trust immediately, and
                creates the foundation for everything else. We are not trying to
                replace every security tool on day one. We are building the
                connective tissue that makes existing tools work together, then
                selectively integrating where we can deliver meaningfully better
                outcomes.
              </p>
              <p data-id="element-4028" data-mp="1gdyf3dhxnht3">
                <span className="font-bold text-[#111111]" data-id="element-4029" data-mp="1gcdk5mrphwup">
                  Platform-agnostic by design.
                </span>{' '}
                We meet families where they are: iOS, Android, Windows, Mac,
                ChromeOS. No ecosystem lock-in, no forced migrations, just
                better security through better understanding.
              </p>
              <p data-id="element-4030" data-mp="xekgujd67kws">
                <span className="font-bold text-[#111111]" data-id="element-4031" data-mp="xf2nm9xglhiy">
                  Role-aware from the start.
                </span>{' '}
                Every feature must serve the multi-generational household. What
                makes sense for a Guardian (the adult child coordinating family
                security) is different from what makes sense for an Adult Member
                (an aging parent) or a Child Member (a grandchild learning
                digital literacy). This distinction shapes every decision we
                make.
              </p>
            </div>
          </section>

          {/* 2. Phase 1 */}
          <section className="border-t border-gray-100 pt-10" data-id="element-4032" data-mp="38d2lqj0t6fk8">
            <div className="flex items-center gap-4 mb-6" data-id="element-4033" data-mp="3d5450owe96jr">
              <h2 className="text-2xl font-bold text-[#631bb7]" data-id="element-4034" data-mp="3d6nloglypjm2">
                Phase 1: The Web App Foundation
              </h2>
              <span className="bg-[#f0ebf8] text-[#631bb7] text-sm font-bold px-3 py-1 rounded-full" data-id="element-4035" data-mp="3n2iajtgs4axa">
                Now through Month 6
              </span>
            </div>

            <p className="text-gray-600 leading-relaxed mb-8" data-id="element-4036" data-mp="3r2izi81i84il">
              Phase 1 establishes Caveo's core web experience and begins iOS
              development in parallel. This is an invite-only, waitlist-gated
              early access period. We are refining the product with real
              families while building toward the iOS launch in Phase 2.
            </p>

            <div className="space-y-8" data-id="element-4037" data-mp="1u77jc7nqmtb3">
              <div data-id="element-4038" data-mp="1pffy8cncpfsc">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4039" data-mp="1pe4yqp0xuu71">
                  Core Value Proposition
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4040" data-mp="1kgctyuf73dlf">
                  Families get immediate clarity, confidence, and actionable
                  next steps through AI-powered personalized education. Within
                  five minutes of arriving on the platform, a user understands
                  where they stand and exactly what to do next.
                </p>
              </div>

              <div data-id="element-4041" data-mp="234rnppgwd5px">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4042" data-mp="238fdcdj817zd">
                  Assessment and Onboarding
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4043" data-mp="rro0nhkdsck8">
                  Caveo uses a two-stage discovery process. The first stage is a
                  3-4 minute quick-win survey that delivers immediate value and
                  begins mapping the household. The second is a 10-minute
                  deep-dive diagnostic that captures the full device inventory,
                  identifies subscription overlap (Wallet Leakage), and maps
                  family topology so we understand who supports whom. The output
                  is a personalized action plan, not a grade.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4044" data-mp="6fqaktf116i0">
                  Goal-first onboarding anchors the experience. Users answer one
                  question first: what brings you here today? Entry paths
                  include:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-4045" data-mp="1gvnvgdxuxsm">
                  <li data-id="element-4046" data-mp="3jn0btrr5x0lb">
                    I think I have been hacked or scammed (Crisis Mode,
                    immediate triage)
                  </li>
                  <li data-id="element-4047" data-mp="3no3roe97mwmj">
                    I want my family to be safer online (Guardian Flow, role
                    selection and family invitation)
                  </li>
                  <li data-id="element-4048" data-mp="30206rrdnez2i">
                    Someone invited me to join their family plan (Join Flow,
                    simplified onboarding)
                  </li>
                  <li data-id="element-4049" data-mp="391wof91mexo2">
                    I want to learn how to protect myself (Solo Adult Flow,
                    personalized assessment)
                  </li>
                  <li data-id="element-4050" data-mp="3nxcmdp5bndpq">
                    I am helping my parent or grandparent get started (Support
                    Flow, guided setup assistance)
                  </li>
                </ul>
              </div>

              <div data-id="element-4051" data-mp="o7mq76q85m2">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4052" data-mp="3sq5py9p20g08">
                  37-Module Curriculum
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4053" data-mp="alc9a84hi33e">
                  Caveo's educational content is structured across three
                  progressive levels plus specialized guides, totaling 10-18
                  hours of guided learning completed at the family's own pace.
                  All content is informed by proven learning science frameworks
                  and designed to be immediately actionable.
                </p>
                <ul className="space-y-3 text-gray-600 mb-4" data-id="element-4054" data-mp="1qxemo8a5xw36">
                  <li data-id="element-4055" data-mp="1qwwj0ql68fl8">
                    <span className="font-bold text-[#111111]" data-id="element-4056" data-mp="1qv27u3zpc1uc">
                      Level 1: Essential Digital Safety:
                    </span>{' '}
                    9 modules, 2.5-4 hours. The foundation every household
                    member needs.
                  </li>
                  <li data-id="element-4057" data-mp="136j0prse1v3u">
                    <span className="font-bold text-[#111111]" data-id="element-4058" data-mp="17yk7iy6setmh">
                      Level 2: Intermediate Protection:
                    </span>{' '}
                    11 modules, 7-12 hours. Building comprehensive household
                    security.
                  </li>
                  <li data-id="element-4059" data-mp="fg6jfqb96m0l">
                    <span className="font-bold text-[#111111]" data-id="element-4060" data-mp="7yqer6tsuxgw">
                      Level 3: Advanced Security Practices:
                    </span>{' '}
                    8 modules, 4-9 hours. For households ready to go further.
                  </li>
                  <li data-id="element-4061" data-mp="3u4doeg6o5fdh">
                    <span className="font-bold text-[#111111]" data-id="element-4062" data-mp="3u81ef5cwnjng">
                      Specialized Guides:
                    </span>{' '}
                    Targeted, situation-specific guidance for scenarios
                    including financial scams, AI safety, identity masking, and
                    more.
                  </li>
                </ul>
                <p className="text-gray-600 leading-relaxed" data-id="element-4063" data-mp="3bgicz2yj4dnj">
                  Every module follows a proven five-part structure: Hook (a
                  relatable story or oops moment), Concept (one key idea per
                  screen with visuals and analogies), Practice (an interactive
                  activity to apply the concept), Reflection (a prompt to
                  connect the lesson to the learner's own life), and Takeaway
                  (one clear action to complete right now). Mastery gates on
                  critical concepts ensure understanding before advancing.
                </p>
              </div>

              <div data-id="element-4064" data-mp="21cvcyqml4m99">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4065" data-mp="1wbxt89lxfk5n">
                  Protection Score
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4066" data-mp="18lbnwq3b4dzc">
                  A 1,000-point scoring system measures capability building
                  across the household. 0 to 450 reflects basic safety hygiene
                  in place. 450 to 1,000 reflects a legitimately secured
                  household. The score is visible on both individual and family
                  dashboards, designed to motivate rather than shame, and
                  updated dynamically as modules are completed and actions are
                  taken.
                </p>
              </div>

              <div data-id="element-4067" data-mp="2wjco4rtb9bvl">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4068" data-mp="2wiumtgrsk7gt">
                  Role-Based Dashboard
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4069" data-mp="31gw17oe9vily">
                  Five distinct roles with appropriate permissions and tailored
                  interfaces: Guardian (full family visibility, billing, module
                  assignment, aggregated Protection Score), Super Guardian
                  (elevated technical permissions, remote assistance
                  capabilities launching in Phase 2), Adult Member (self-managed
                  with optional Guardian oversight), Child Member
                  (age-appropriate content with Guardian-approved permissions),
                  and Account Member (individual access without family
                  participation).
                </p>
              </div>

              <div data-id="element-4070" data-mp="6v3ncee0keaj">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4071" data-mp="6vlrryatxytj">
                  Living Tech Roadmap and Infrastructure Management
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4072" data-mp="brg2op4d50bb">
                  Caveo tracks each household's device ecosystem with lifecycle
                  awareness. Ecosystem-aware shopping guides warn families
                  against common purchasing mistakes (such as buying
                  incompatible or redundant hardware) and surface
                  recommendations based on what the family already owns. Device
                  health indicators surface OS version status, MFA enablement,
                  router security checklist completion, and backup status.
                </p>
              </div>

              <div data-id="element-4073" data-mp="3g6gxhb8myef7">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4074" data-mp="3g6z1wv5gbyy7">
                  Crisis Response Guide
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4075" data-mp="3b8nqwh3f7iee">
                  Accessible without signup. The Crisis Response Guide is
                  Caveo's primary top-of-funnel tool and serves as the entry
                  point for families in crisis. When someone searches for help
                  after a scam or account compromise, they find Caveo's
                  comprehensive, empathetic triage.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4076" data-mp="1zpqkpr59cz26">
                  Triage pathways include:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600 mb-4" data-id="element-4077" data-mp="1309acyvbyou5">
                  <li data-id="element-4078" data-mp="17x9gf9s6jrl9">
                    Did you send money or gift cards (financial fraud protocol)
                  </li>
                  <li data-id="element-4079" data-mp="1by335ztvz0ck">
                    Did you click a link or download something (malware
                    assessment)
                  </li>
                  <li data-id="element-4080" data-mp="k8q3ggy6qqmu">
                    Did you share passwords or account information (account
                    compromise workflow)
                  </li>
                  <li data-id="element-4081" data-mp="o88n79e9svo3">
                    Are you being threatened or blackmailed (escalation to
                    authorities)
                  </li>
                </ul>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4082" data-mp="7ojd4gig2g9">
                  Every path provides real-time guidance, clear next steps, and
                  referrals to appropriate resources including the FTC, FBI IC3,
                  local law enforcement, and bank fraud departments. There is no
                  sugarcoating and no signup required.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-4083" data-mp="ixmujtflubo4">
                  The Crisis Response Guide creates the relationship with
                  families at their most vulnerable moment and serves as the
                  soft conversion point into the paid platform. It is the most
                  important acquisition asset Caveo owns.
                </p>
              </div>

              <div data-id="element-4084" data-mp="2un5vwkkm0xhn">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4085" data-mp="2unpe82e69nw7">
                  AI Advisor (Launches Month 4)
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4086" data-mp="1a6pnxekl3l6u">
                  Caveo's AI Advisor is a conversational support layer that is
                  contextually aware of the family's setup, progress, and device
                  ecosystem. It handles natural language troubleshooting (for
                  example, my mom cannot log into her email), delivers
                  step-by-step guided resolution with screenshots, and escalates
                  to human support for complex issues. Available 24/7 and
                  accessible from within the platform at any time.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-4087" data-mp="meivurlw60d8">
                  The AI Advisor also powers vendor evaluation and shopping
                  assistance. Families receive plain-English comparison guides,
                  honest recommendations that include telling families when they
                  do not need to buy anything, and implementation support for
                  any tool they choose. Caveo earns no affiliate revenue, which
                  is what makes these recommendations credible.
                </p>
              </div>

              <div data-id="element-4088" data-mp="25dp5v6blm7fc">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4089" data-mp="25fa00uu03oco">
                  iOS Development (Running in Parallel)
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4090" data-mp="2y12xcowj2as2">
                  iOS development runs concurrently with the web app throughout
                  Phase 1. Target: TestFlight closed beta in September with
                  100-500 power users drawn from the web app. Full iOS launch is
                  planned for October, coinciding with Cybersecurity Awareness
                  Month, and is the centerpiece of Phase 2.
                </p>
              </div>
            </div>
          </section>

          {/* 3. Phase 2 */}
          <section className="border-t border-gray-100 pt-10" data-id="element-4091" data-mp="3bzswsb6tkmjl">
            <div className="flex items-center gap-4 mb-6" data-id="element-4092" data-mp="3kbusyxohl08x">
              <h2 className="text-2xl font-bold text-[#631bb7]" data-id="element-4093" data-mp="3obv6mg3rh7ex">
                Phase 2: iOS Launch, Remote Assist, and Human Concierge
              </h2>
              <span className="bg-[#f0ebf8] text-[#631bb7] text-sm font-bold px-3 py-1 rounded-full" data-id="element-4094" data-mp="3t9wpazx9z4pv">
                Months 7 through 12
              </span>
            </div>

            <p className="text-gray-600 leading-relaxed mb-8" data-id="element-4095" data-mp="7388vyafamhd">
              Phase 2 transforms Caveo from an education platform into a full
              family technology partner. The iPhone app launches in October
              during Cybersecurity Awareness Month. Remote Assist and the
              Concierge service introduce hands-on support capability. Android
              development begins. By the end of Phase 2, Caveo is competing
              directly with Geek Squad and HelloTech at a fraction of the cost
              with unlimited support.
            </p>

            <div className="space-y-8" data-id="element-4096" data-mp="1g3rd0k0mmm9j">
              <div data-id="element-4097" data-mp="1g2pphg2fc7ax">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4098" data-mp="1g6dlclvcd5st">
                  iOS App Launch (Month 7, October)
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4099" data-mp="1p45zvnt8o9f5">
                  The iPhone app launches publicly in October. This timing is
                  deliberate: Cybersecurity Awareness Month provides a natural
                  earned media hook and a concentrated window of consumer
                  attention. The app delivers feature parity with the web
                  experience, optimized for mobile with biometric login, push
                  notifications, and offline module access.
                </p>
              </div>

              <div data-id="element-4100" data-mp="11djs7xn5cr5o">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4101" data-mp="dq24cd706d7z">
                  Remote Assist
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4102" data-mp="8rqy0cfx2kui">
                  Remote Assist launches on desktop in October alongside the iOS
                  app. It enables two distinct use cases: Guardian-to-family
                  support (a family member helping a parent or grandparent
                  remotely) and Caveo staff-to-family support (escalated
                  technical assistance from the Caveo team). Every session
                  requires explicit consent, is logged, and includes a session
                  recording for safety and compliance. The boundary between a
                  Guardian helping and Caveo intervening is always transparent.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4103" data-mp="2u4x99nbl8rk4">
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-4104" data-mp="2z2yofx5w86qb">
                    <p className="text-gray-600" data-id="element-4105" data-mp="1ioyrmv2cgx7a">
                      <span className="font-bold text-[#111111]" data-id="element-4106" data-mp="1io784im0upxd">Pricing:</span>{' '}
                      <span className="font-bold text-[#631bb7]" data-id="element-4107" data-mp="1nobmo33ddaky">
                        $9.99 per month
                      </span>{' '}
                      for unlimited Remote Assist access.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-4108" data-mp="22ufyvs53nekk">
                    <p className="text-gray-600" data-id="element-4109" data-mp="1owhn8ui5xw8r">
                      <span className="font-bold text-[#111111]" data-id="element-4110" data-mp="1sxtfl7sf8vkn">
                        Competitive context:
                      </span>{' '}
                      Geek Squad and HelloTech charge $99-199 per incident.
                      Caveo delivers ongoing access for a monthly flat fee,
                      representing 10-20x better value for families who need
                      regular support.
                    </p>
                  </div>
                </div>
              </div>

              <div data-id="element-4111" data-mp="w7k64upou5hl">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4112" data-mp="w951unnqnuh1">
                  Wallet Leakage Detection and Subscription Audit
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4113" data-mp="hlde6lnjtsyf">
                  Building on the initial onboarding assessment, Phase 2
                  introduces a deeper subscription audit layer. Families can
                  securely connect accounts to surface redundant service spend
                  across their household. The platform identifies overlapping
                  subscriptions, flags services the family is paying for but not
                  using, and surfaces consolidation opportunities in plain
                  English. This feature reinforces Caveo's fiduciary
                  positioning: we save families money rather than adding to
                  their stack.
                </p>
              </div>

              <div data-id="element-4114" data-mp="15c0n9a97aomk">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4115" data-mp="15bhcqelvr2ik">
                  Centralized Family Tech Inbox
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4116" data-mp="1ebnmpqiddkcz">
                  All issues, alerts, and support requests across the family
                  land in one shared view. Guardians can assign tasks to
                  themselves, to a specific family member, or to the Caveo
                  Concierge team. Every item has status tracking (Open, In
                  Progress, Waiting, Resolved) and a playbook-driven resolution
                  path. Completed actions generate proof of completion and an
                  audit trail.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-4117" data-mp="uqtppj13xmme">
                  This layer becomes Caveo's most defensible infrastructure. The
                  family's entire digital safety history, every issue resolved,
                  every task completed, every configuration change made, lives
                  inside Caveo. That history creates meaningful switching costs
                  and becomes the foundation for the intelligence layer that
                  develops in Phases 3 and 4.
                </p>
              </div>

              <div data-id="element-4118" data-mp="32wm4ji8zmuwc">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4119" data-mp="32x48z25t0ffc">
                  Phishing Campaign Testing
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4120" data-mp="2y3t06vhfloks">
                  An optional, consent-based feature for families who want to
                  pressure-test what they have learned. Caveo sends simulated
                  phishing emails and smishing SMS messages to consenting family
                  members. If a family member clicks, they receive immediate
                  feedback and targeted remedial education rather than shame.
                  The experience is gamified: Can you spot the scam? This
                  feature is particularly effective for households with aging
                  adults who are high-value targets for social engineering
                  attacks.
                </p>
              </div>

              <div data-id="element-4121" data-mp="1wf8rt2pxy8ea">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4122" data-mp="1wep9hkwdphzq">
                  Data Broker Removal and Dark Web Monitoring (Partner)
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4123" data-mp="3p4862pgqyc4a">
                  Caveo integrates with data broker removal APIs and breach
                  monitoring services to surface household exposure in a single
                  dashboard. Plain-English explanations accompany every alert:
                  here is what this means, here is why it matters, and here is
                  exactly what to do next. Action buttons connect directly into
                  the Concierge workflow for families who want hands-on
                  remediation support.
                </p>
              </div>

              <div data-id="element-4124" data-mp="2voz9tzut9kb">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4125" data-mp="2v5fe7qn8b3n">
                  Concierge Service
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4126" data-mp="2ippbtvx5l0d0">
                  For complex issues that go beyond what the AI Advisor and
                  Remote Assist can resolve, Caveo offers on-demand white-glove
                  support from dedicated technical experts. Concierge is
                  designed for situations like full device migrations, complex
                  smart home configurations, incident response after a confirmed
                  compromise, or families managing the digital affairs of a
                  cognitively declining parent.
                </p>
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 inline-block" data-id="element-4127" data-mp="1wd4iixck710a">
                  <p className="text-gray-600" data-id="element-4128" data-mp="1re1bx8gxkmq7">
                    <span className="font-bold text-[#111111]" data-id="element-4129" data-mp="265a5ttrv8u95">Pricing:</span>{' '}
                    <span className="font-bold text-[#631bb7]" data-id="element-4130" data-mp="21ejywc3skjcc">
                      $199 per hour
                    </span>
                    . No bundles, no subscriptions. Families pay for exactly
                    what they need.
                  </p>
                </div>
              </div>

              <div data-id="element-4131" data-mp="38sdzbsqd6vrc">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4132" data-mp="38qt6q8nm1mw4">
                  Android Development Begins
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4133" data-mp="3douo8p5e1e5h">
                  Android development starts in Month 7 and runs through the end
                  of Phase 2. The fragmentation challenge of the Android
                  ecosystem, thousands of device configurations and OS versions
                  requiring extensive QA, is why Android follows iOS rather than
                  launching simultaneously. Feature parity is the target by the
                  Phase 3 launch.
                </p>
              </div>
            </div>
          </section>

          {/* 4. Phase 3 */}
          <section className="border-t border-gray-100 pt-10" data-id="element-4134" data-mp="33u2njcgieb6h">
            <div className="flex items-center gap-4 mb-6" data-id="element-4135" data-mp="e2fn3yjxniho">
              <h2 className="text-2xl font-bold text-[#631bb7]" data-id="element-4136" data-mp="j2k21k57055s">
                Phase 3: Android Launch and Strategic Integrations
              </h2>
              <span className="bg-[#f0ebf8] text-[#631bb7] text-sm font-bold px-3 py-1 rounded-full" data-id="element-4137" data-mp="t55yx4qyo485">
                Months 12 through 18
              </span>
            </div>

            <p className="text-gray-600 leading-relaxed mb-8" data-id="element-4138" data-mp="jfw3bewws3fa">
              Phase 3 delivers the Android app and expands the platform through
              a combination of Caveo-native features and strategic third-party
              integrations. The build-versus-partner decision framework is
              applied rigorously: Caveo builds where we can deliver a
              meaningfully better family-aware experience, and partners where an
              excellent solution already exists and integration is sufficient.
            </p>

            <div className="space-y-8" data-id="element-4139" data-mp="3snp27sowzghn">
              <div data-id="element-4140" data-mp="1uwcolov59ea2">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4141" data-mp="1uut8by9hn38a">
                  Android App Launch (Month 12)
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4142" data-mp="1qs4ufc5x364g">
                  The Android app launches with full feature parity to iOS. With
                  both platforms live, Caveo covers more than 95% of the
                  smartphone market. The Android launch removes the last major
                  accessibility barrier for families with mixed-device
                  households.
                </p>
              </div>

              <div data-id="element-4143" data-mp="1qeia6yfnk3f1">
                <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-4144" data-mp="1qdyor7qsmww9">
                  Caveo-Native Features (We Build)
                </h3>
                <div className="space-y-6" data-id="element-4145" data-mp="1vc0ay1jincby">
                  <div data-id="element-4146" data-mp="1hf3kw2b81yw4">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-4147" data-mp="1hfwiacoajc1l">
                      Email Alias Generation
                    </h4>
                    <p className="text-gray-600 leading-relaxed" data-id="element-4148" data-mp="1mf9dbkpbfpf9">
                      A lightweight, hide-my-email style service that generates
                      unique email aliases for signups, online shopping, and
                      account creation. This prevents spam, reduces data breach
                      exposure, and makes it easier to identify and cut off
                      compromised addresses. Delivered in plain English with no
                      technical setup required.
                    </p>
                  </div>
                  <div data-id="element-4149" data-mp="3uw6cav31knsv">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-4150" data-mp="3uuv7crxv1a06">
                      Family SSO and Identity Access Management
                    </h4>
                    <p className="text-gray-600 leading-relaxed" data-id="element-4151" data-mp="8i6eobrzdqyu">
                      A unified authentication portal for the household, modeled
                      on how Okta became indispensable to enterprises. Once
                      families authenticate through Caveo SSO, Caveo becomes the
                      gateway layer for their digital life. This is one of the
                      most important moat-building features on the roadmap: once
                      a family is authenticating through Caveo, switching costs
                      become very high. This feature mirrors enterprise IAM
                      practices applied to the household context.
                    </p>
                  </div>
                  <div data-id="element-4152" data-mp="1jdibwxbxa8kb">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-4153" data-mp="1jcytlfid1i5r">
                      Family Verification Protocol and Deepfake Defense
                    </h4>
                    <p className="text-gray-600 leading-relaxed" data-id="element-4154" data-mp="1ag811d30olfx">
                      With AI-powered voice cloning and deepfake technology
                      making impersonation attacks more sophisticated every
                      year, families need a verified way to confirm they are
                      actually talking to each other. Caveo builds safe word
                      creation flows, deepfake scam rehearsal scenarios, and
                      emergency response checklists into the platform. Families
                      practice recognizing and responding to impersonation
                      attempts before they happen.
                    </p>
                  </div>
                </div>
              </div>

              <div data-id="element-4155" data-mp="374pryg87fa40">
                <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-4156" data-mp="3747s79mc2drc">
                  Strategic Integrations (We Partner)
                </h3>
                <div className="space-y-6" data-id="element-4157" data-mp="3c312yua8jqnt">
                  <div data-id="element-4158" data-mp="2fe1v3gdkcqw5">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-4159" data-mp="2feldey74lhap">
                      Password Manager Integration
                    </h4>
                    <p className="text-gray-600 leading-relaxed" data-id="element-4160" data-mp="2jgyj5mlvhf7h">
                      OAuth integration with 1Password, iCloud Keychain, and
                      Google Password Manager provides a unified view of
                      password health across the household. Caveo does not build
                      a competing password manager. Instead, we teach families
                      how to choose the right one for their situation, guide
                      them through setup and browser integration, and surface
                      weak or reused passwords in the dashboard. This is the
                      adoption gap that existing password manager vendors have
                      failed to close, and it is one of Caveo's clearest
                      value-adds.
                    </p>
                  </div>
                  <div data-id="element-4161" data-mp="2wd1qihpn3mgh">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-4162" data-mp="2wemhjxcqwn9l">
                      Financial Wellbeing Monitoring
                    </h4>
                    <p className="text-gray-600 leading-relaxed" data-id="element-4163" data-mp="363nzvu6rjgqq">
                      API connections with providers like Aura, IdentityGuard,
                      and Credit Karma deliver a consolidated view of credit
                      monitoring, dark web scans, and financial alerts within
                      the Caveo dashboard. Families get one place to see their
                      exposure without managing multiple separate logins and
                      interfaces.
                    </p>
                  </div>
                  <div data-id="element-4164" data-mp="sxzqemc2rtdw">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-4165" data-mp="syj0xhzebfhw">
                      Backup Service Integration
                    </h4>
                    <p className="text-gray-600 leading-relaxed" data-id="element-4166" data-mp="j6vdds5ymilp">
                      Read-only coordination with iCloud, Google Drive,
                      Backblaze, and Carbonite verifies that backups are
                      enabled, recent, and actually restorable. Caveo surfaces
                      family-wide backup status and guides restoration testing.
                      The most common backup failure mode is discovering the
                      backup did not work when you actually need it. Caveo
                      addresses this proactively.
                    </p>
                  </div>
                  <div data-id="element-4167" data-mp="3mo3sw5d7t6d9">
                    <h4 className="font-bold text-[#111111] mb-2" data-id="element-4168" data-mp="3momyqnplc4ax">
                      Social Impersonation Monitoring
                    </h4>
                    <p className="text-gray-600 leading-relaxed" data-id="element-4169" data-mp="1yvsz5h5h1ru">
                      Partner integration for monitoring unauthorized use of
                      family members' identities on social platforms. This is
                      particularly relevant for households with aging adults who
                      are high-value targets for account impersonation and
                      romance scams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 5. Phase 4 */}
          <section className="border-t border-gray-100 pt-10" data-id="element-4170" data-mp="foh2zqcz26nq">
            <div className="flex items-center gap-4 mb-6" data-id="element-4171" data-mp="bpglqca57c2u">
              <h2 className="text-2xl font-bold text-[#631bb7]" data-id="element-4172" data-mp="br1kyf7ejj71">
                Phase 4: Unified Platform and Intelligence Layer
              </h2>
              <span className="bg-[#f0ebf8] text-[#631bb7] text-sm font-bold px-3 py-1 rounded-full" data-id="element-4173" data-mp="2wdv0azgm0896">
                Months 18 through 36
              </span>
            </div>

            <p className="text-gray-600 leading-relaxed mb-8" data-id="element-4174" data-mp="1fxyy1lf837w4">
              Phase 4 deepens the intelligence and orchestration layer rather
              than building competing point solutions. By this stage, Caveo has
              accumulated meaningful behavioral data, family graph intelligence,
              and a track record of household security outcomes. That foundation
              enables a fundamentally different kind of product: one that
              anticipates problems rather than reacting to them.
            </p>

            <div className="space-y-8" data-id="element-4175" data-mp="23okt8c44oxop">
              <div data-id="element-4176" data-mp="28n5xqnqey3iy">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4177" data-mp="28ne92b6w10s1">
                  Predictive Threat Intelligence
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4178" data-mp="9buzpvho9qhu">
                  Personalized threat intelligence based on each family's
                  profile, device ecosystem, behavior patterns, and regional
                  threat landscape. Rather than generic alerts, families receive
                  specific, contextual warnings: this type of scam is actively
                  targeting households with your profile in your area, and here
                  is what to watch for. The platform moves from reactive to
                  genuinely predictive.
                </p>
              </div>

              <div data-id="element-4179" data-mp="20gsbo2gcq7hu">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4180" data-mp="1vjthjjwou0jn">
                  AI-Powered Scam Detection
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4181" data-mp="29a5blocu29df">
                  Proactive monitoring that surfaces scam attempts with
                  plain-English explanations of what is happening and why.
                  Rather than a technical alert that a suspicious email was
                  detected, families receive a clear explanation of the social
                  engineering technique being used, why it targets people like
                  them, and exactly what to do. Education and protection are
                  delivered in the same moment.
                </p>
              </div>

              <div data-id="element-4182" data-mp="2nx413ds4qtpi">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4183" data-mp="2nxnkz01cbs66">
                  Predictive Maintenance
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4184" data-mp="2f5lo1bqhcu0n">
                  Anticipating hardware failures, alerting to device end-of-life
                  before it becomes a crisis, flagging software that is
                  approaching unsupported status, and identifying configurations
                  that are likely to cause problems before they do. The
                  Centralized Family Tech Inbox built in Phase 2 becomes the
                  operational backbone for this layer, with proactive tasks
                  surfacing automatically rather than waiting for a family
                  member to notice a problem.
                </p>
              </div>

              <div data-id="element-4185" data-mp="2glhkihskx744">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4186" data-mp="2bp0lgsjud8c9">
                  Insurance Partnership
                </h3>
                <p className="text-gray-600 leading-relaxed mb-2" data-id="element-4187" data-mp="26omoc5js3it0">
                  A cyber insurance integration that plugs directly into Caveo's
                  orchestration layer. This is introduced only after Caveo has
                  accumulated meaningful data on claim frequency and household
                  risk profiles, and has negotiated terms that reflect Caveo's
                  education-first, lower-risk customer base. When an incident
                  occurs, the claim process becomes a guided workflow inside the
                  platform rather than a PDF download and a phone call. Families
                  who have completed the curriculum and maintained high
                  Protection Scores should qualify for favorable terms that
                  reflect their lower actual risk.
                </p>
                <p className="text-gray-500 italic text-sm" data-id="element-4188" data-mp="3lp3bm12k4vyt">
                  *Insurance is added last, after data and claim frequency are
                  well understood. This sequencing is intentional.*
                </p>
              </div>

              <div data-id="element-4189" data-mp="3hdt4030ra89">
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-4190" data-mp="3glyosl5rijk">
                  B2B2C Institutional Partnerships (Maturing)
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4191" data-mp="36xkx67pcj9hk">
                  By Phase 4, the B2B2C channel is generating meaningful revenue
                  and building toward category leadership. Institutional
                  partnerships with senior living communities, financial
                  institutions, and Medicare Advantage plans are fully
                  operational, with white-label experiences, admin dashboards,
                  and revenue share structures in place. These partnerships
                  expand Caveo's reach into the hardest-to-acquire demographics
                  at dramatically lower CAC than direct consumer channels.
                </p>
              </div>
            </div>
          </section>

          {/* 6. Strategic Priorities Across All Phases */}
          <section className="border-t border-gray-100 pt-10" data-id="element-4192" data-mp="1ixpj1jc86xny">
            <h2 className="text-2xl font-bold mb-6 text-[#631bb7]" data-id="element-4193" data-mp="1izaah038u0hl">
              Strategic Priorities Across All Phases
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8" data-id="element-4194" data-mp="1rxciw0pb3vew">
              These principles apply to every feature decision across the entire
              roadmap, regardless of phase.
            </p>

            <div className="space-y-6" data-id="element-4195" data-mp="21wbk4y7qsorv">
              <div data-id="element-4196" data-mp="21va7ipb2vu81">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-4197" data-mp="21tpdd0soedap">
                  Education Always Comes First
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4198" data-mp="7h919jd784xx">
                  Even as Caveo adds managed services and integrations,
                  education remains the core. Every feature must answer one
                  question: how does this help families learn and improve?
                  Features that deliver capability without understanding create
                  dependency. Features that build understanding first create
                  loyalty.
                </p>
              </div>
              <div data-id="element-4199" data-mp="33q4w70hprxgn">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-4200" data-mp="33qmr9tsn45mz">
                  Platform-Agnostic, Forever
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4201" data-mp="2uqhro5toubjd">
                  Caveo will never lock families into a device ecosystem. iOS
                  and Android. Mac and Windows. ChromeOS. Mixed households. We
                  support all of them. This is both a product principle and a
                  competitive positioning decision: Apple and Google cannot
                  serve mixed-device households without conflicts of interest.
                  Caveo can, and we always will.
                </p>
              </div>
              <div data-id="element-4202" data-mp="1krfcc6o6031g">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-4203" data-mp="1krylaxvu7h3c">
                  Role-Aware, Always
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4204" data-mp="16v1wt336ybpm">
                  Every feature must serve the multi-generational household.
                  Guardians, Adult Members, Child Members, and Account Members
                  have fundamentally different relationships to technology,
                  different risk profiles, and different support needs. A
                  feature that works well for a 45-year-old Guardian may be
                  intimidating or irrelevant for a 72-year-old Adult Member.
                  Role-aware design is not a nice-to-have; it is the core of
                  what makes Caveo different.
                </p>
              </div>
              <div data-id="element-4205" data-mp="j57h8drhm91o">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-4206" data-mp="3vmqsro13f3hw">
                  Privacy by Design
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4207" data-mp="3qofjbeepmv07">
                  Caveo will never sell user data. Caveo will never use
                  surveillance as a business model. We earn money by genuinely
                  helping families, not by monetizing their behavior. Zero
                  affiliate revenue preserves the integrity of every
                  recommendation we make. This is not a marketing position; it
                  is a structural commitment built into how the company
                  operates.
                </p>
              </div>
              <div data-id="element-4208" data-mp="n7728wrt3z6j">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-4209" data-mp="n6nidailj0pv">
                  Build Versus Partner Decision Framework
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4210" data-mp="114lwcet08v4u">
                  Caveo partners when an existing solution is excellent and
                  approachable, when integration is sufficient for user needs,
                  and when building would produce an undifferentiated outcome.
                  Caveo builds when existing solutions are too complex or
                  technical for mainstream families, when integration
                  limitations create a poor user experience, when we can deliver
                  a meaningfully better family-aware outcome, and when revenue
                  capture justifies the development investment. This framework
                  keeps the roadmap disciplined and prevents scope creep into
                  areas where Caveo would not win.
                </p>
              </div>
            </div>
          </section>

          {/* 7. Competitive Moats We Are Building */}
          <section className="border-t border-gray-100 pt-10" data-id="element-4211" data-mp="3t2u346o5vvr7">
            <h2 className="text-2xl font-bold mb-6 text-[#631bb7]" data-id="element-4212" data-mp="3t4dno9guosys">
              Competitive Moats We Are Building
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-4213" data-mp="1lh2erdpiqadx">
              The roadmap is designed to compound over time. Each phase adds a
              layer of defensibility that makes Caveo harder to displace.
            </p>
            <ul className="space-y-4 text-gray-600" data-id="element-4214" data-mp="1cmxrf49lfh35">
              <li className="flex items-start" data-id="element-4215" data-mp="17pe31bj6lnxh">
                <span className="mr-3 mt-1 text-[#631bb7]" data-id="element-4216" data-mp="17omiqwv1bcmi">•</span>
                <span data-id="element-4217" data-mp="12qkr3njjm4zf">
                  <span className="font-bold text-[#111111]" data-id="element-4218" data-mp="12qugpa0oea4l">
                    Proprietary Educational Content:
                  </span>{' '}
                  37 modules, continuously updated, backed by learning science.
                  A competitor would need 12-18 months and $500K-1M to replicate
                  the content alone, and still would not have the family graph
                  data or usage patterns that make Caveo's personalization
                  effective.
                </span>
              </li>
              <li className="flex items-start" data-id="element-4219" data-mp="2j285kbdf924v">
                <span className="mr-3 mt-1 text-[#631bb7]" data-id="element-4220" data-mp="328o1nuu3djak">•</span>
                <span data-id="element-4221" data-mp="36zmkp26gsvhi">
                  <span className="font-bold text-[#111111]" data-id="element-4222" data-mp="37066itz8k40t">
                    Family Graph and Behavioral Data:
                  </span>{' '}
                  Understanding family dynamics, device ecosystems, literacy
                  levels, and household risk profiles. The AI personalization
                  improves with usage, and the data compounds: more families
                  means better recommendations for every family.
                </span>
              </li>
              <li className="flex items-start" data-id="element-4223" data-mp="3byzj8k6p7qzx">
                <span className="mr-3 mt-1 text-[#631bb7]" data-id="element-4224" data-mp="3by7mh61d7n82">•</span>
                <span data-id="element-4225" data-mp="3gxapym1p5ldx">
                  <span className="font-bold text-[#111111]" data-id="element-4226" data-mp="3gwivxfnqzvpr">
                    Multi-Generational UX Expertise:
                  </span>{' '}
                  Designing for Boomers and Gen Z simultaneously within the same
                  product is extremely difficult to execute well. It requires
                  deep user research, extensive testing, and genuine empathy for
                  users across a wide range of technical literacy. This is not
                  something a competitor can acquire quickly.
                </span>
              </li>
              <li className="flex items-start" data-id="element-4227" data-mp="2207vp85oz52w">
                <span className="mr-3 mt-1 text-[#631bb7]" data-id="element-4228" data-mp="221iz36v86ath">•</span>
                <span data-id="element-4229" data-mp="1eadgwl1tb6g0">
                  <span className="font-bold text-[#111111]" data-id="element-4230" data-mp="1ebom8pawom98">
                    Platform-Agnostic Positioning:
                  </span>{' '}
                  The only player serving mixed-device households without
                  ecosystem conflicts. Apple and Google cannot do this by
                  design. Legacy vendors lack the organizational will. Caveo
                  occupies this position by strategic choice.
                </span>
              </li>
              <li className="flex items-start" data-id="element-4231" data-mp="qmcfdw31wqa3">
                <span className="mr-3 mt-1 text-[#631bb7]" data-id="element-4232" data-mp="qjhuy4k1f5go">•</span>
                <span data-id="element-4233" data-mp="612c1mwvh2zr">
                  <span className="font-bold text-[#111111]" data-id="element-4234" data-mp="61k4e8geyx2e">
                    Trust in Crisis Moments:
                  </span>{' '}
                  The Crisis Response Guide builds the relationship when
                  families are most vulnerable. That trust is extraordinarily
                  difficult to replicate and is the foundation of every
                  conversion and retention outcome that follows.
                </span>
              </li>
              <li className="flex items-start" data-id="element-4235" data-mp="sz5994lxeew6">
                <span className="mr-3 mt-1 text-[#631bb7]" data-id="element-4236" data-mp="sxu533okj54j">•</span>
                <span data-id="element-4237" data-mp="xrgl95txxr53">
                  <span className="font-bold text-[#111111]" data-id="element-4238" data-mp="xszzkqw1ds48">
                    Education Plus Managed Services Hybrid:
                  </span>{' '}
                  Scalable education combined with high-touch human support.
                  Competitors are either pure product or pure service. Caveo's
                  combination is unique and creates a moat that neither side of
                  the market can easily replicate.
                </span>
              </li>
            </ul>
          </section>
        </div>
      </main>

      <footer className="bg-white border-t border-gray-200 py-8 mt-12" data-id="element-4239" data-mp="2n7iudmwist8c">
        <div className="max-w-7xl mx-auto px-6 text-center text-sm text-gray-500" data-id="element-4240" data-mp="2i8z6vi2a39dv">
          <p data-id="element-4241" data-mp="2ib28z0gpgsyy">&copy; 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.</p>
          <p className="mt-2 text-xs text-gray-400" data-id="element-4242" data-mp="3fw6ma1bryguv">
            This page contains confidential information intended only for
            authorized investors. Do not share or distribute without permission.
          </p>
        </div>
      </footer>
    </div>;
}